import { TextField } from '@mui/material';

export type BirthplaceInputProps = {
  value: string | null;
  onChange: (value: string | null) => void;
  label: string;
};

export function BirthplaceInput({
  value,
  onChange,
  label,
}: BirthplaceInputProps) {
  return (
    <TextField
      type='text'
      label={label}
      size='small'
      value={value}
      onChange={event =>
        onChange(event.target.value === '' ? null : event.target.value)
      }
      fullWidth
    />
  );
}
